import FilterMultiSelectBox from "./filterMultiSelectBox";
import { genderList } from "../helper";
import { useGenderFilter } from "../filters/useGenderFilter";
import _ from "lodash";

const FilterGender = ({ talentFilter, talentFilterTags, onAddFilter }) => {
  const {
    selectedGender,
    setSelectedGender,
    buildGenderFilter,
  } = useGenderFilter(talentFilter, talentFilterTags);

  const extractGenderNames = (values) => {
    return genderList[0].options
      .filter(o => values.includes(o.value))
      .map(o => o.label);
  };

  const handleAdd = () => {
    const payload = buildGenderFilter(
      extractGenderNames(selectedGender)
    );

    if (!payload) return;

    onAddFilter("gender", payload);
  };

  return (
    <FilterMultiSelectBox
      title="GENDER (Select one or several)"
      label="Select gender or search"
      list={genderList}
      selectedValue={selectedGender}
      onChange={setSelectedGender}
      onAddFilter={handleAdd}
    />
  );
};

export default FilterGender;
